export const signIn = (credentials) => {
    return async (dispatch, getState, {getFirebase}) => {
        const firebase = getFirebase();

        await firebase.auth().signInWithEmailAndPassword(
            credentials.email, 
            credentials.password
        ).then( () => {
            console.log('Login Success');
            dispatch( {type: 'LOGIN_SUCCESS' })
        }).catch((err) => {
            console.log('Login Error - ' + err);
            dispatch( {type: 'LOGIN_ERROR', err })
        });
    }
}

export const signOut = () => {
    return async (dispatch, getState, {getFirebase}) => {
        const firebase = getFirebase();

        await firebase.auth().signOut().then(() => {
            dispatch({type: 'SIGNOUT_SUCCESS'});
        }).catch((err) => {
            dispatch( {type: 'SIGNOUT_ERROR', err })
        })
    }
}

export const signUp = (newUser) => {
    return async (dispatch, getState, {getFirebase, getFirestore}) => {
        const firebase = getFirebase();
        const firestore = getFirestore();

        await firebase.auth().createUserWithEmailAndPassword(
            newUser.email, 
            newUser.password
        ).then( (resp) => {
            return firestore.collection('users').doc(resp.user.uid).set({
                firstname: newUser.firstname,
                lastname: newUser.lastname,
                initials: newUser.firstname[0] + newUser.lastname[0]
            }).then(() => {
                dispatch( {type: 'SIGNUP_SUCCESS' })
            }).catch (err => {
                dispatch( {type: 'SIGNUP_ERROR', err })                
            })
        }).catch((err) => {
            dispatch( {type: 'SIGNUP_ERROR', err })
        });
    }
}

export const updateprofile = (currentUser, user, useruid) => {
    return (dispatch, getState, {getFirebase, getFirestore}) => {
        const firebase = getFirebase();
        const firestore = getFirestore();

        return firestore.collection('users').doc(useruid).set({
            firstname: user.firstname,
            lastname: user.lastname,
            initials: user.firstname[0] + user.lastname[0],
            profileimageurl: user.profileimageurl,
        }).then(() => {
            // if (user.profileimageurl) {
            //     firebase.auth().updateProfile(currentUser, {photoURL: user.profileimageurl});
            //     dispatch( {type: 'UPDATEPROFILE_SUCCESS' })
            // } else {
            //     dispatch( {type: 'UPDATEPROFILE_SUCCESS' })
            // }
            dispatch( {type: 'UPDATEPROFILE_SUCCESS' })
        }).catch (err => {
            dispatch( {type: 'UPDATEPROFILE_ERROR', err })                
        })
    }
}